module.exports = __webpack_public_path__ + "d521a7127c5ef26c9d04653f6bd5dc05.svg";